var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.55 63.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.43,11.16A13.82,13.82,0,0,1,25.89,16.6,13.84,13.84,0,1,1,47.22,34.2,19.1,19.1,0,0,0,42.07,47v9.61a5.75,5.75,0,0,1-5.75,5.74h0a5.74,5.74,0,0,1-5.74-5.74V44.78a4.69,4.69,0,0,0-4.69-4.69h0a4.68,4.68,0,0,0-4.68,4.69v11.8a5.75,5.75,0,0,1-5.75,5.74h0a5.74,5.74,0,0,1-5.74-5.74V47A19.11,19.11,0,0,0,4.56,34.2a13.84,13.84,0,0,1,8.87-23Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.21,
    y1: 8.33,
    x2: 55.36,
    y2: 4.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.68,
    y1: 12.96,
    x2: 58.55,
    y2: 12.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.58,
    y1: 6.86,
    x2: 46.78,
    y2: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,31.75l-7.05.65a3.15,3.15,0,0,1-1.85-.4L35,29.19a3.2,3.2,0,0,1-1.6-2.27l-.26-1.58a3.22,3.22,0,0,0-2.6-2.63l-1.45-.26a3.2,3.2,0,0,1-2.58-2.53l-.66-3.32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset12);
export default __webpack_public_path__ + "static/media/Asset 12.e0bd388cea822361eec0ad03460a37c3.svg";
export { ForwardRef as ReactComponent };